import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import PurchasePage from './pages/PurchasePage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage';
import AboutPage from './pages/AboutPage';
import MissionPage from './pages/MissionPage';
import CareersPage from './pages/CareersPage';
import BlogPage from './pages/BlogPage';
import HelpPage from './pages/HelpPage';
import SupportPage from './pages/SupportPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/course/:id" element={<CourseDetailPage />} />
            <Route path="/purchase/:id" element={<PurchasePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/legal/:type" element={<LegalPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/mission" element={<MissionPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/support" element={<SupportPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
